import { useLocation, Link } from 'react-router-dom';
import { API_BASE_URL } from '../dppApi';
import { useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from './AuthProvider';
import NavBar from './NavBar.js';
import bracelet from "../images/bracelet.jpeg"
import receipt from "../images/receipt.jpeg"
import appraisal from "../images/appraisal.jpg"
import certificate from "../images/certificate.jpeg"

const staticCatalog =
{
    key: "1",
    picture: bracelet,
    description: "Bracelet",
    metal: "925 Silver",
    stone: [],
    brand: "Tiffany & Co.",
    datePurchased: "Mar 14, 2024",
    storageLocation: "BoFA San Francisco",
    history: `This item was gifted to me by my daughter for my fortieth birthday. 
        She surprised me at midnight with a birthday party involving immediate family 
        members and friends. She got the item engraved with I love you, mom.`,
    receipt: receipt,
    appraisal: appraisal,
    certificate: certificate,
}

const JewelleryDetails = () => {
    const location = useLocation();
    const {user} = useContext(AuthContext);
    const data = location.state;
    const [jewelleryDetails, setJewelleryDetails] = useState({});
    
    const focusRef = useRef(null);

    useEffect(() => {
        if (focusRef.current) {
            focusRef.current.focus();
        }
    }, []);

    
    useEffect(() => {

        const itemKey = data.key;
        const baseUrl = `${API_BASE_URL}/api/get-jewellery-details`;
        //const baseUrl = "http://ec2-54-167-84-208.compute-1.amazonaws.com:5000/api/get-jewellery-details"
    
        const params = new URLSearchParams();
        params.append('itemKey', itemKey);
    
        const url = `${baseUrl}?${params.toString()}`;
    
        // Make the GET request
        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${user}`,
            }})
            .then(response => response.json())
            .then(data => setJewelleryDetails({...data}))
            .catch(error => console.error('Error:', error));
    }, [])

    return (
        <div>
            <NavBar />
            <div className="empty-div-50" id="focus-ref" tabIndex="-1" ref={focusRef}></div>
            <div className="jewellery-detail-container-row-1">
                <div className="item">
                        <img src={jewelleryDetails.image} height="300" width="300"/></div>
                <div className="item" background-color="#F5F5F5">
                    {jewelleryDetails.history ? jewelleryDetails.history : 
                    ""}</div>
            </div>
            <div className="jewellery-detail-container-row-2">
                <Link to='/jewellery/details/update' state={data}>Update Jewellery</Link>
            </div>
            <div className="empty-div-30"></div>
            <div className="receipt-appraisal-certificate">
                <img src={jewelleryDetails.receipt} className="img-css" />
                <img src={jewelleryDetails.appraisal} className="img-css" />
                <img src={jewelleryDetails.certificate} className="img-css"  />
            </div>
        </div>
    );
}

export default JewelleryDetails;